import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const buyers = [{
  title: "Electrical Contractors",
  description: "Legend plates, panel nameplates, panel schedules, and pushbutton plates — often on a deadline.",
  linkText: "Contractor solutions",
  linkUrl: "/industries/electrical-contractors/"
}, {
  title: "Facility & MRO Engineers",
  description: "Valve tags, asset tags, pipe markers, and lockout/tagout tags for plant-wide identification.",
  linkText: "Facility labeling",
  linkUrl: "/industries/manufacturing/"
}, {
  title: "Specifying Engineers",
  description: "Arc flash labels and MIL-SPEC phenolic, specified from a project manual.",
  linkText: "Specifier resources",
  linkUrl: "/industries/specifying-engineers/"
}, {
  title: "OEM Manufacturers",
  description: "Equipment nameplates and recurring data-plate programs.",
  linkText: "OEM programs",
  linkUrl: "/industries/oem-equipment/"
}];
export default function BrowseByBuyer() {
  return <section id="browse-by-buyer" className="bg-background">
      <div className="bg-popover text-popover-foreground py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6">
          <h2 className="text-3xl md:text-4xl font-default font-bold mb-12 text-center">
            What Do Buyers Like You Order Most?
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {buyers.map((buyer, i) => <Card key={i} data-index={i} className="bg-secondary border-border flex flex-col h-full hover:border-primary transition-colors duration-300 shadow-md">
                <CardHeader>
                  <CardTitle className="text-xl font-default text-accent">
                    {buyer.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-card-foreground font-default text-sm md:text-base leading-relaxed">
                    {buyer.description}
                  </p>
                </CardContent>
                <CardFooter>
                  <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 font-default text-base">
                    <Link to={buyer.linkUrl}>
                      {buyer.linkText} <ArrowRight className="ml-1.5 size-4" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}